import { VContent } from 'vuetify/lib/components/VContent';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden full-height d-flex"},[_c(VContent,{staticClass:"flex-fit yc-overflow-x-hidden"},[_c('div',{staticClass:"yc-body-main-wrapper full-height"},[_c('my-default-layout',{attrs:{"x-options":_vm.data}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }